import { HttpHeaders, HttpParams } from "@angular/common/http";
import { Router } from "@angular/router";
import {
  Component,
  OnInit,
  Input,
  Output,
  SimpleChanges,
  EventEmitter,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { ServiciosService } from "src/app/core/services/servicios.service";
import { IntegracionServices } from "src/app/core/services/integraciones.service";
import { lastValueFrom, takeUntil, Subject } from "rxjs";
import Swal, { SweetAlertIcon } from "sweetalert2";
import { k } from "src/environments/properties";

@Component({
  selector: "app-bucket",
  templateUrl: "./bucket.component.html",
  styleUrls: ["./bucket.css"],
})
export class BucketComponent implements OnInit {
  private destroy$ = new Subject<void>();

  public formServiciosBucket: FormGroup;
  public closeResult: string = "";
  spinner: boolean = false;
  toast = Swal;
  idBucket: number = 0;
  idServicio: string = "";
  isEditMode = false;
  formServiciosBucketIsSubmited = false;
  jsonValido = false;
  BucketDefault = true;

  @Input() idBucketP: number = 0;
  @Input() idBucketDefault: number = 0;
  @Output() saved = new EventEmitter<any>();

  constructor(
    private seriviciosServices: ServiciosService,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private integracionServices: IntegracionServices,
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  async ngOnInit() {
    this.toastAlert();
    this.initUserForm();

    this.route.paramMap.pipe(takeUntil(this.destroy$)).subscribe((params) => {
      const id = params.get("id");
      // const idBucket = params.get("id_bucket");

      if (id && this.idBucketP) {
        this.idServicio = id;
        this.idBucket = this.idBucketP;

        this.showBucket();
      }
    });
  }

  async ngOnChanges(changes: SimpleChanges) {
    if (changes["idBucketP"] && this.idBucketP) {
      const idServicio = this.route.snapshot.paramMap.get("id");

      if (!idServicio) {
        return;
      }

      this.idServicio = idServicio;
      this.idBucket = this.idBucketP;

      await this.showBucket();
    }
  }

  ngAfterViewInit(): void {}

  async crearServicioBucket() {
    //const idServicio = this.route.snapshot.paramMap.get("id");
    this.idServicio = this.route.snapshot.paramMap.get("id");

    this.formServiciosBucketIsSubmited = true;
    if (!this.formServiciosBucket.valid) {
      this.formServiciosBucket.markAllAsTouched();
      return false;
    }

    const formValue = this.formServiciosBucket.getRawValue();
    const { es_predeterminado, ...bucketData } = formValue;
    const payload = {
      ...bucketData,
      credencialesJson: JSON.parse(bucketData.credencialesJson),
    };

    try {
      let response = await lastValueFrom(
        this.seriviciosServices.crearConfigBucket(payload, this.idServicio),
      );

      this.idBucket = response.id;
      if (formValue.es_predeterminado === true) {
        response = await this.establecerBucketPredeterminado(response.id);
      }

      this.alert("success", "Éxito!", "Bucket Registrado!");
      this.saved.emit(response);
    } catch (error) {
      console.error("Error al crear configuración del bucket:", error);
    }

    this.formServiciosBucketIsSubmited = false;
  }

  async CloseModal() {
    this.saved.emit();
  }

  async editarServicioBucket() {
    this.formServiciosBucketIsSubmited = true;
    if (!this.formServiciosBucket.valid) {
      this.formServiciosBucket.markAllAsTouched();
      return false;
    }

    const formValue = this.formServiciosBucket.getRawValue();
    const { es_predeterminado, ...bucketData } = formValue;
    const payload = {
      ...bucketData,
      credencialesJson: JSON.parse(bucketData.credencialesJson),
    };

    try {
      const response = await lastValueFrom(
        this.seriviciosServices.updBucket(
          payload,
          this.idServicio,
          this.idBucketP,
        ),
      );

      this.idBucket = response.id;
      if (formValue.es_predeterminado === true) {
        await this.establecerBucketPredeterminado(response.id);
      } else {
        if (this.BucketDefault) {
          //si es que era el predeterminado y el usuario lo desactivo mandamos a quitarlo como predeterminado
          await this.establecerBucketPredeterminado(null);
        }
      }

      this.alert("success", "Éxito!", "Sistema actualizado!");
      this.saved.emit(response);
    } catch (error) {
      console.error("Error al crear configuración del sistema:", error);
    }

    this.formServiciosBucketIsSubmited = false;
  }

  async showBucket() {
    const response = await lastValueFrom(
      this.seriviciosServices.showBucket(this.idServicio, this.idBucketP),
    );
    const servicioBucket = response.body;
    this.isEditMode = true;
    if (!servicioBucket) return;

    this.formServiciosBucket.patchValue({
      proveedor: servicioBucket.proveedor,
      region: servicioBucket.region,
      bucketOContenedor: servicioBucket.bucketOContenedor,
      credencialesJson: JSON.stringify(
        servicioBucket.credencialesJson,
        null,
        2,
      ),
      es_predeterminado: this.idBucket == this.idBucketDefault ? true : false,
    });

    this.BucketDefault = this.idBucket == this.idBucketDefault ? true : false;

    this.formatJson();
  }

  guardarServicioBucket() {
    if (this.isEditMode) {
      this.editarServicioBucket();
    } else {
      this.crearServicioBucket();
    }
  }

  async establecerBucketPredeterminado(idBucket: number | null): Promise<void> {
    try {
      const payload = {
        id_servicio_externo_storage_config_predeterminado: idBucket,
      };

      await lastValueFrom(
        this.seriviciosServices.editarServicio(payload, this.idServicio),
      );
    } catch (error) {
      console.error("Error al establecer bucket predeterminado:", error);

      throw error;
    }
  }

  initUserForm(): void {
    this.formServiciosBucket = this.fb.group({
      proveedor: ["", [Validators.required, Validators.minLength(2)]],
      region: ["", [Validators.required, Validators.minLength(3)]],
      bucketOContenedor: ["", [Validators.required, Validators.minLength(3)]],
      es_predeterminado: ["", []],
      credencialesJson: ["", [Validators.required]],
    });
  }

  openModalContent(
    content: any,
    mode: boolean,
    size: "sm" | "lg" | "xl" = "lg",
    windowClass?: string,
  ) {
    this.modalService
      .open(content, {
        ariaLabelledBy: "modal-basic-title",
        size,
        centered: true,
        windowClass,
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        },
      );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  //  INICIO METODOS PARA EL BUCKET
  formatJsonOnPaste(): void {
    setTimeout(() => {
      this.formatJson();
    });
  }

  formatJson(): void {
    const control = this.formServiciosBucket.get("credencialesJson");
    const value = control?.value;

    if (!value) {
      this.jsonValido = false;
      return;
    }

    try {
      const json = JSON.parse(value);

      control?.setValue(JSON.stringify(json, null, 2), { emitEvent: false });

      this.jsonValido = true;
    } catch {
      this.jsonValido = false;
    }
  }

  copyJson(): void {
    const value = this.formServiciosBucket.get("credencialesJson")?.value;

    if (!value) {
      return;
    }

    navigator.clipboard.writeText(value);
  }

  //  FIN METODOS PARA EL BUCKET

  toastAlert() {
    this.toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      },
    });
  }

  alert(icontext: SweetAlertIcon, title: string, text: string = "") {
    this.toast.fire({
      icon: icontext,
      title: title,
      text: text,
    });
  }
}
